import { render } from "./ethics_whistleblowing.html?vue&type=template&id=5304b0cb&external"
import script from "./ethics_whistleblowing.js?vue&type=script&lang=js&external"
export * from "./ethics_whistleblowing.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__